import { c as _c } from "react/compiler-runtime";
import styles from './TripCard.module.css';
import type { TripCardPlacesProps } from './TripCard.types';
const TripCardPlaces = t0 => {
  const $ = _c(2);
  const {
    places
  } = t0;
  if (process.env.NEXT_PUBLIC_FF_ENABLE_TRIP_CARD_PLACES !== "true" || !places) {
    return null;
  }
  let t1;
  if ($[0] !== places) {
    t1 = <p data-test-id="trip-card-places" className={styles.locations}>{places}</p>;
    $[0] = places;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export { TripCardPlaces };